import { render, staticRenderFns } from "./SKDataTable.vue?vue&type=template&id=60508d4f&"
import script from "./SKDataTable.vue?vue&type=script&lang=js&"
export * from "./SKDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SKDataTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports